import React from 'react'
import { SarshAndSebastionLogo } from '../../necklace-builder/icons/Logo'
import useWindowSize from '../customHooks/useWindowSize'
import { CloseIcon } from '../ui-components/Icons'
import { Result } from '../types/types';

declare global {
  interface Window {
    openDrawer: () => void;
    closeDrawer: () => void;
  }
}

type Props = {
  setSearchTerms: React.Dispatch<React.SetStateAction<string>>
  setProducts: React.Dispatch<React.SetStateAction<Result[] | null>>
  setNoResults: React.Dispatch<React.SetStateAction<boolean>>
}



const SearchHeader = ({setSearchTerms, setProducts, setNoResults}: Props): JSX.Element | null => {
  const windowSize = useWindowSize()
  if (windowSize.width <= 640) {
    return null
  }
  
  const closeDrawer = () => {
    window.closeDrawer()
    setSearchTerms('')
    setProducts(null)
    setNoResults(false)
  }

  return (
    <div className='px-5 pt-4 pb-2.5 flex border-b border-border-secondary mb-[109px] items-center'> 
      <div className="w-1/4"></div>
      <div className="w-2/4 flex justify-center">
        <SarshAndSebastionLogo />
      </div>
      <div className="w-1/4 flex justify-end">
        <CloseIcon onClick={closeDrawer}/>
      </div>
    </div>
  )
}

export default SearchHeader